export default {"src":"/_next/static/media/logo.8ad6b695.svg","height":56,"width":250,"blurWidth":0,"blurHeight":0};